import './style.css';

function Home() {
    return (
        <div id="home">
            <div id="invitation-container">
                <div className="invitation-content"><h1>ACCUEIL</h1></div>
                <br/>
                <div className="invitation-content">
                    Chers parents, chères amies, chers amis,
                </div>
                <br/><br/>
                <div className="invitation-content">
                    Nous sommes ravies de vous accueillir sur le site du groupe Phoenix organisé pour proposer aux jeunes des activités qui leur donneront l’occasion de se rencontrer dans une ambiance chaleureuse et conviviale.
                </div>
                <br/>
                <div className="invitation-content">
                    Nous vous invitons à parcourir attentivement les informations disponibles sur ce site. Vous y trouverez tout ce qu’il faut savoir sur le groupe, son esprit et ses activités.
                </div>
                <br/>
                <div className="invitation-content">
                    Nous remercions les parents qui se sont déjà engagés dans l'organisation d'une activité ou soirée pour le groupe.
                </div>
                <br/>
                <div className="invitation-content">
                    Votre engagement est précieux. Nous serons bien sûr présentes pour vous accompagner. Sans vous, Phoenix ne pourrait tout simplement pas prendre son envol !
                </div>
                <br/>
                <div className="invitation-content"> {/*Correction 4*/}
                    N'hésitez pas à nous contacter (phoenix1211.groupe@gmail.com) pour les prochaines dates et saisons, le calendrier de toutes les saisons sera mis à jour au fur et à mesure.
                </div>
                <br/>
                <div className="invitation-content">
                    Enfin, afin de préserver la confidentialité du site, nous vous remercions de ne pas partager le mot de passe ainsi que les informations publiées sur ce site.
                </div>
                <br/><br/>
                <div className="invitation-content">
                    Nous sommes impatientes de vous retrouver,
                </div>
                <br/><br/>
                <div className="invitation-content invitation-names"><p>Aurélie, Caroline, Charlotte, Maroussia et Wivine</p></div>
            </div>
        </div>
    )
}

export default Home;